import { useFormContext } from 'react-hook-form';
import ReportsFiltersField from './ReportsFiltersField';
import { PermittedReportsData } from '../types/permittedReports.type';

interface ReportsFiltersFieldsProps {
  filters?: PermittedReportsData['filters'];
}

const ReportsFiltersFields = ({ filters }: ReportsFiltersFieldsProps) => {
  const { control, watch, resetField, formState: { errors } } = useFormContext();

  return (
    <>
      {filters && Object.keys(filters)?.map((filterName) => (
        <ReportsFiltersField
          key={filterName}
          filterName={filterName}
          filterProps={filters[filterName]}
          control={control}
          errors={errors}
          resetField={resetField}
          watch={watch}
        />
      ))}
    </>
  );
};

export default ReportsFiltersFields;
